import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { AuthService } from '@auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import Utils from '@shared/utils/utils';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
  animations: fuseAnimations
})
export class OtpComponent implements OnInit {

  otpForm: FormGroup;
  otpFormErrors: any;
  spinner = false;
  error: any;
  token: any;
  rememberMe: boolean;

  pageTitle = 'Secondary Authentication';
  pageGuide = `Verification code sent to you. Please enter it below.`;

  constructor(private fuseConfig: FuseConfigService,
              private formBuilder: FormBuilder,
              private authService: AuthService,
              private dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) {

    const { token, rememberMe } = this.authService.getOtpToken();
    this.token = token;
    this.rememberMe = rememberMe;

    if (token.sentTo) {
      this.pageGuide = `Verification code sent to ${token.sentTo}. Please enter it below.`;
    }

    // Configure the layout
    this.fuseConfig.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

    this.otpFormErrors = {
      code: {}
    };
  }

  ngOnInit() {
    this.otpForm = this.formBuilder.group({
      code: [this.route.snapshot.queryParams.code || '', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });

    this.otpForm.valueChanges.subscribe(() => {
      this.onOtpFormValuesChanged();
    });

    const map = this.route.snapshot.paramMap;
  }

  onOtpFormValuesChanged() {
    for (const field in this.otpFormErrors) {
      if (!this.otpFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.otpFormErrors[field] = {};

      const control = this.otpForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.otpFormErrors[field] = control.errors;
      }
    }
  }

  otpLogin() {
    const value = this.otpForm.value;

    this.spinner = true;

    const code = value.code;
    this.error = null;
    this.authService.otpLogin(this.token.username, this.token.tfaToken, code, this.token.rememberMe)
      .subscribe(result => {
        this.spinner = false;

        if (this.rememberMe) {
          localStorage.setItem('lastUser', this.token.username);
        } else {
          localStorage.removeItem('lastUser');
        }


        if (this.authService.redirectUrl && this.authService.redirectUrl === '/auth/login') {
          this.authService.redirectUrl = null;
        }
        const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '';
        // Redirect the user
        this.router.navigate([redirect]);
      }, (response: any) => {
        this.error = response.error.message;
        if (response.status === 429) {
          this.error = 'Too many login attempts. Please try again later.';
        }
        Utils.showError(this.dialog, this.error);
        this.spinner = false;
      });

    return false;
  }

  resendCode() {
    this.spinner = true;
    this.error = null;
    this.authService.resendOtp(this.token.username, this.token.tfaToken)
      .subscribe((token: any) => {
        this.authService.setOtpToken(token, this.rememberMe);
        this.token = token;
        this.spinner = false;
        Utils.showMessage(this.dialog, `New verification code has been resent to ${this.token.sentTo}.`);
      }, (response: any) => {
        this.spinner = false;
        this.error = response.error.message;
        if (response.status === 429) {
          this.error = 'Too many login attempts. Please try again later.';
        }
        Utils.showError(this.dialog, this.error);
      });
  }
}
